import {
  AfterViewInit,
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { Item, UIComponents } from '@ntap/core';
import { first, map, Observable, tap } from 'rxjs';
import { OdabirPovezaneOsobeProviderDirective } from './odabir-povezane-osobe.provider';

@Component({
  selector: 'app-odabir-osobe',
  templateUrl: './odabir-osobe.html'
})
export class SelectOsobaComponent implements OnInit, AfterViewInit {
  @Output()
  itemSelected = new EventEmitter<any[]>();

  @ViewChild(OdabirPovezaneOsobeProviderDirective)
  appOdabirPovezaneOsobeProvider: OdabirPovezaneOsobeProviderDirective;

  tablica = [
    'seup~subjekt~vrsta_osobe',
    'seup~subjekt~oib',
    'seup~subjekt~mb',
    'seup~subjekt~putovnica_broj',
    'seup~subjekt~ime',
    'seup~subjekt~prezime',
    'seup~subjekt~naziv'
  ];

  INIT_COMP_ID = UIComponents.LISTVIEW;
  currentViewName: string;
  currentViewState: object | null;
  currentViewStateFilter: object;

  disabled$: Observable<boolean>;

  private selectedItems$: Observable<Item[] | null>;

  ngOnInit(): void {
    this.currentViewName = 'seup.subjekti';
    this.currentViewState = {};
    this.currentViewStateFilter = {};
  }

  public ngAfterViewInit(): void {
    this.selectedItems$ = this.appOdabirPovezaneOsobeProvider.selectedItems$;
    this.disabled$ = this.selectedItems$.pipe(map((i) => !i || i.length == 0));
  }

  public selectItem() {
    this.selectedItems$
      .pipe(
        first(),
        tap((items) => {
          if (!!items && items.length > 0) {
            this.itemSelected.next(items as any[]);
          }
        })
      )
      .subscribe();
  }
}
